import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import SearchUspItem from "@/components/SearchComponent/UnbxdComponents/SearchUsps/SearchUspItem";
import { useTranslation } from "@i18n";
import HowToBuySection from "@/pages/homePageV2/homePageComponents/components/HowToBuy/HowToBuySection";
import useBoolean from "@hooks/useBoolean";
import useFilterPage from "@/pages/search/searchHooks/useSearchAndFilters";
import { useLocation } from "react-router-dom";
import SearchUspLearnMore from "@/components/SearchComponent/UnbxdComponents/SearchUsps/SearchUspLearnMore";

// Define USP data types

var SearchUspsContext = /*#__PURE__*/createContext(undefined);
export var SearchUspsProvider = function SearchUspsProvider(_ref) {
  var _selectedUsp$learnMor, _selectedUsp$learnMor2;
  var children = _ref.children;
  var _useTranslation = useTranslation(),
    tLong = _useTranslation.tLong,
    tShort = _useTranslation.tShort;
  var _useState = useState(typeof window !== 'undefined' ? window.innerWidth : 0),
    screenWidth = _useState[0],
    setScreenWidth = _useState[1];
  var popup = useBoolean();
  var _useFilterPage = useFilterPage(),
    isAutosPage = _useFilterPage.isAutosPage,
    page = _useFilterPage.page;
  var location = useLocation();

  // State to track the selected USP for the modal
  var _useState2 = useState(null),
    selectedUsp = _useState2[0],
    setSelectedUsp = _useState2[1];

  // now check if the page url have 'condition_id=1' in it , but this might be server side render make the dep
  var isNewPage = useMemo(function () {
    // use the location from react-router-dom
    var params = new URLSearchParams(location.search);
    var conditionId = params.get('condition_id');
    // add condition to check that the location have /autos/new-cars
    // and the condition_id is 1
    return conditionId === '1' || location.pathname.includes('/autos/new-cars');
    // return conditionId === '1';
  }, [location.search, location.pathname]);
  useEffect(function () {
    var handleResize = function handleResize() {
      setScreenWidth(window.innerWidth);
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  // Sample USP data - replace with your actual USPs
  var usps = useMemo(function () {
    if (isNewPage) return [{
      id: 1,
      title: tShort("searchUsp/usp_new_one_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_new_one_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/riyal.svg",
      pattern: "circle",
      learnMore: {
        title: tShort("searchUsp/usp_new_one_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_new_one_learn_description", {
          ns: "web_search"
        })
      }
    }, {
      id: 2,
      title: tShort("searchUsp/usp_new_two_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_new_two_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/daman.svg",
      pattern: "wave",
      learnMore: {
        title: tShort("searchUsp/usp_new_two_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_new_two_learn_description", {
          ns: "web_search"
        })
      }
    }, {
      id: 3,
      title: tShort("searchUsp/usp_new_three_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_new_three_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/map.svg",
      pattern: "circle",
      learnMore: {
        title: tShort("searchUsp/usp_new_three_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_new_three_learn_description", {
          ns: "web_search"
        })
      }
    }, {
      id: 4,
      title: tShort("searchUsp/usp_new_four_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_new_four_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/delivery-new.svg",
      pattern: "wave",
      learnMore: {
        title: tShort("searchUsp/usp_new_four_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_new_four_learn_description", {
          ns: "web_search"
        })
      }
    }];
    return [{
      id: 1,
      title: tShort("searchUsp/usp_one_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_one_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/days.svg",
      pattern: "circle",
      learnMore: {
        title: tShort("searchUsp/usp_one_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_one_learn_description", {
          ns: "web_search"
        })
      }
    }, {
      id: 2,
      title: tShort("searchUsp/usp_two_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_two_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/year.svg",
      pattern: "wave",
      learnMore: {
        title: tShort("searchUsp/usp_two_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_two_learn_description", {
          ns: "web_search"
        })
      }
    }, {
      id: 3,
      title: tShort("searchUsp/usp_three_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_three_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/checked.svg",
      pattern: "circle",
      learnMore: {
        title: tShort("searchUsp/usp_three_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_three_learn_description", {
          ns: "web_search"
        })
      }
    }, {
      id: 4,
      title: tShort("searchUsp/usp_four_title", {
        ns: "web_search"
      }),
      description: tLong("searchUsp/usp_four_description", {
        ns: "web_search"
      }),
      icon: "/assets/images/usps/delivery.svg",
      pattern: "wave",
      learnMore: {
        title: tShort("searchUsp/usp_four_learn_title", {
          ns: "web_search"
        }),
        description: tLong("searchUsp/usp_four_learn_description", {
          ns: "web_search"
        })
      }
    }];
  }, [tShort, tLong, isNewPage]);

  // Helper function to handle USP item click
  var handleUspClick = function handleUspClick(usp) {
    setSelectedUsp(usp);
    popup.setTrue();
  };

  // Determine what to render based on car index and device type
  var renderUsps = function renderUsps(carIndex, isMobile) {
    var pairSequence = [[0, 1],
    // USPs 1-2
    [2, 3],
    // USPs 3-4
    [0, 1],
    // USPs 1-2
    [2, 3] // USPs 2-4
    ];
    if (isAutosPage) {
      if (!isMobile) {
        // Check if we need to render anything (every 8 cars)
        if (carIndex % 8 !== 0 || carIndex === 0) {
          return null;
        }

        // Determine which pair to show based on page number
        if (page % 3 === 0) {
          return renderHowToBuy(carIndex);
        } else {
          // Calculate effective page for sequence
          // This accounts for skipped pages (when page % 3 === 0)
          var skippedPages = Math.floor((page - 1) / 3);
          var effectivePage = page - skippedPages;

          // Use effective page to determine which pair to show
          var pairIndex = (effectivePage - 1) % pairSequence.length;
          var _pairSequence$pairInd = _slicedToArray(pairSequence[pairIndex], 2),
            firstUspIndex = _pairSequence$pairInd[0],
            secondUspIndex = _pairSequence$pairInd[1];
          return /*#__PURE__*/React.createElement("div", {
            className: "col-span-full"
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex gap-4"
          }, renderUspItem(usps[firstUspIndex]), renderUspItem(usps[secondUspIndex])));
        }
      } else {
        if (carIndex === 0 || carIndex % 4 !== 0) return null;

        // Determine active slot (1-based)
        var slot = carIndex / 4;

        // Define display sequences by page parity - adjusted for 4 USPs
        var oddSequence = [0, 1, 2];
        var evenSequence = [3, 'howToBuy'];
        var sequence = page % 2 !== 0 ? oddSequence : evenSequence;

        // Convert slot to 0-based index
        var idx = slot - 1;
        if (idx < 0 || idx >= sequence.length) return null;
        var target = sequence[idx];
        return /*#__PURE__*/React.createElement("div", {
          className: "col-span-full"
        }, target === 'howToBuy' ? renderHowToBuy(carIndex) : renderUspItem(usps[target]));
      }
    } else {
      if (!isMobile) {
        // Determine the frequency based on screen width
        var frequency = screenWidth >= 1200 && screenWidth <= 1500 ? 6 : 8;

        // Check if we need to render anything (every 6 or 8 cars)
        if (carIndex % frequency !== 0 || carIndex === 0) {
          return null;
        }

        // Determine which iteration we're on
        var iteration = Math.floor(carIndex / frequency);

        // Every 5th item should be How to Buy (usp1 usp2 -> usp3 usp4 -> howToBuy, repeat)
        var _sequence = [[0, 1],
        // USPs 1-2
        [2, 3],
        // USPs 3-4
        'howToBuy' // How to Buy section
        ];

        // Calculate the current sequence index
        var sequenceIndex = (iteration - 1) % _sequence.length;
        var _target = _sequence[sequenceIndex];
        if (_target === 'howToBuy') {
          return renderHowToBuy(carIndex);
        } else {
          var _ref2 = _target,
            _ref3 = _slicedToArray(_ref2, 2),
            _firstUspIndex = _ref3[0],
            _secondUspIndex = _ref3[1];
          return /*#__PURE__*/React.createElement("div", {
            className: "col-span-full"
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex gap-4"
          }, renderUspItem(usps[_firstUspIndex]), renderUspItem(usps[_secondUspIndex])));
        }
      } else {
        // Check if we need to render anything (every 4 cars)
        if (carIndex % 4 !== 0 || carIndex === 0) {
          return null;
        }

        // Determine which iteration we're on
        var _iteration = Math.floor(carIndex / 4);

        // Every 5th item should be How to Buy (1,2,3,4,HowToBuy, repeat)
        var totalItems = usps.length + 1;
        var contentIndex = (_iteration - 1) % totalItems;

        // If it's the last item in our cycle, show How to Buy
        if (contentIndex === usps.length) {
          return renderHowToBuy(carIndex);
        } else {
          // Otherwise show the USP at contentIndex
          return /*#__PURE__*/React.createElement("div", {
            className: "col-span-full"
          }, renderUspItem(usps[contentIndex]));
        }
      }
    }
  };

  // Helper function to render a single USP item
  var renderUspItem = function renderUspItem(usp) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchUspItem, {
      id: isNewPage ? usp.id + 4 : usp.id,
      title: usp.title,
      src: usp.icon,
      description: usp.description,
      pattern: usp.pattern,
      variant: isNewPage ? "green" : "default",
      onLearnMoreClick: function onLearnMoreClick() {
        return handleUspClick(usp);
      }
    }));
  };

  // Helper function to render How to Buy section
  var renderHowToBuy = function renderHowToBuy(carIndex) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-span-full lg:relative lg:bg-white rounded-xl lg:overflow-hidden lg:px-8 lg:my-[19px]"
    }, /*#__PURE__*/React.createElement(HowToBuySection, {
      key: 'howtoBuySection' + carIndex,
      showDescription: false,
      className: "px-0 lg:bg-white",
      innerWrapperClassName: "lg:bg-[transparent] z-[2] relative lg:py-6"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hidden lg:block lg:absolute w-full h-full top-0 left-0 z-[1] lg:object-cover lg:transform lg:scale-105",
      src: "/assets/images/usps/wave.svg",
      alt: "wave"
    }));
  };
  return /*#__PURE__*/React.createElement(SearchUspsContext.Provider, {
    value: {
      renderUsps: renderUsps
    }
  }, children, /*#__PURE__*/React.createElement(SearchUspLearnMore, {
    onClose: popup === null || popup === void 0 ? void 0 : popup.setFalse,
    src: selectedUsp === null || selectedUsp === void 0 ? void 0 : selectedUsp.icon,
    open: popup.value,
    title: selectedUsp === null || selectedUsp === void 0 ? void 0 : (_selectedUsp$learnMor = selectedUsp.learnMore) === null || _selectedUsp$learnMor === void 0 ? void 0 : _selectedUsp$learnMor.title,
    description: selectedUsp === null || selectedUsp === void 0 ? void 0 : (_selectedUsp$learnMor2 = selectedUsp.learnMore) === null || _selectedUsp$learnMor2 === void 0 ? void 0 : _selectedUsp$learnMor2.description
  }));
};

// Custom hook to use the context
export var useSearchUsps = function useSearchUsps() {
  var context = useContext(SearchUspsContext);
  if (context === undefined) {
    throw new Error('useSearchUsps must be used within a SearchUspsProvider');
  }
  return context;
};
export default SearchUspsContext;